
import { Component, Prop, Vue } from "vue-property-decorator";

const ICONS = {
  alert: "alert-circle",
};

@Component
export default class ComplianceExpiredWidget extends Vue {
  @Prop({ type: Boolean, default: false }) readonly fromHomePage!: boolean;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly description!: string;

  icons = ICONS;
}
